export default __webpack_public_path__ + "static/media/trial.8fd4fc70.svg";